import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// SNS 로그인 임시 데이터 타입 정의

interface UserStore {
  userId?: string | null;
  setUserId: (userId?: string) => void;
}

// 임시 인증 데이터 스토어 생성 (로컬 스토리지 사용으로 변경)
const useUserStore = create<UserStore>()(
  persist(
    (set, get) => ({
      userId: null,

      // 임시 데이터 저장
      setUserId: (userId?: string) => {
        set({ userId });
      }
    }),
    {
      name: 'computer-exam-admin-user-storage' // 로컬 스토리지 키 이름
      // storage 옵션을 제거하면 기본적으로 localStorage를 사용함
      // Flutter WebView에서 새로운 인스턴스가 생성되어도 데이터가 유지됨
    }
  )
);

export default useUserStore;
